import { render, staticRenderFns } from "./combat-test.vue?vue&type=template&id=72d93a2b&scoped=true"
import script from "./combat-test.vue?vue&type=script&lang=js"
export * from "./combat-test.vue?vue&type=script&lang=js"
import style0 from "./combat-test.vue?vue&type=style&index=0&id=72d93a2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d93a2b",
  null
  
)

export default component.exports